<ng-container *ngIf="vm$ | async as vm">
	<div class="flex">
		<div class="flex flex-col flex-1">
			<div
				class="mb-1 flex justify-start gap-2 items-center"
				*ngIf="vm.primaryJurisdiction"
			>
				<label>Jurisdiction</label>
				<app-icon
					*ngIf="showAiIcon$ | async"
					[icon]="AI_ICON"
					[classes]="AI_CLASSES"
					[matTooltip]="AI_TOOLTIP"
				/>
			</div>
			<div *ngIf="vm.primaryJurisdiction" class="flex flex-1 items-center">
				<div class="flex">
					<app-pill
						[remove]="true"
						(onRemove)="onDeleteJurisdiction()"
						[testHook]="testHooks.PrimaryJurisdictionPill"
						>{{ vm.primaryJurisdiction.name }}</app-pill
					>
				</div>
			</div>

			<app-jurisdiction-search-dropdown
				*ngIf="!vm.primaryJurisdiction"
				(onSelect)="onSelectJurisdiction($event)"
				[jurisdictionString]="jurisdiction"
				[testHook]="testHooks.JurisdictionSearchDropdown"
			></app-jurisdiction-search-dropdown>
		</div>

		<app-sale-lro class="flex-1 ml-5" [showAiIcon]="true"></app-sale-lro>
	</div>

	<div class="w-full mt-6" *ngIf="vm.showMlttToast">
		<atomic-toast (dismiss)="dismissMlttToast()" [testHook]="testHooks.Toast">
			<p>
				<span
					class="text-green underline cursor-pointer"
					(click)="goToLTT()"
					[testHook]="testHooks.GoToLttSpan"
					>MLTT</span
				><ng-container *ngIf="vm.isLROToronto; else mlttOtherText">
					calculations have been applied.</ng-container
				>
				<ng-template #mlttOtherText>
					calculations are still applied to this file.</ng-template
				>
			</p>
		</atomic-toast>
	</div>

	<div *ngIf="vm.hasVacantTaxJurisdiction" class="mt-6">
		<app-checkbox
			type="clear"
			[ngModel]="vm.primaryJurisdiction.applyVacantTax"
			(ngModelChange)="toggleVacantTaxCheckbox($event)"
			label="Vacant home tax applicable"
			[testHook]="testHooks.VacantHomeTaxApplicableCheckbox"
		></app-checkbox>
	</div>

	<div
		*ngIf="vm.vacantTaxAdjustment && vm.hasVacantTaxJurisdiction"
		class="my-2"
	>
		<app-anchor
			class="text-green cursor-pointer"
			[testHook]="testHooks.GoToVacantTaxAdjustmentLink"
			(click)="goToVacantTaxAdjustment()"
			>Edit vacant tax adjustment
		</app-anchor>
	</div>
</ng-container>
